import * as React from 'react'

import * as styles from './LegalTerm.module.scss'
import { tradeMarkSymbolParser } from 'util/titleParser'

export const LegalStatement = ({ name, label, required }) => {
  return (
    <div className={styles.labelCheckboxClassStatement} key={name}>
      {required ? <span className={styles.asterisk}>*</span> : null}{' '}
      <span
        className={styles.label}
        style={{ fontSize: '0.75rem' }}
        dangerouslySetInnerHTML={{
          __html: tradeMarkSymbolParser(label),
        }}
      />
    </div>
  )
}
